/**
 * @description Примесь планов лечения пациента.
 */
export default {
  computed: {
    /**
     * @description Создание плана.
     * @type {boolean}
     */
    isCreate({ $route, $options }) {
      const { planId } = $route.params;
      return planId === $options.createPlanRouteName;
    },
  },
  createPlanRouteName: 'create',
  methods: {
    /**
     * @description Получить локацию.
     * @param {number}        patientId Идентификатор пациента.
     * @param {number|string} planId    Идентификатор плана.
     * @returns {any}
     */
    getLocation(patientId, planId) {
      return { name: 'ClinicPanelPatientPlan', params: { id: patientId, planId } };
    },
    /**
     * @description Получить локацию формы создания плана.
     * @param {number}        patientId Идентификатор пациента.
     * @param {number|string} planId    Идентификатор плана.
     * @returns {any}
     */
    getFormCreationLocation(patientId) {
      return this.getLocation(patientId, this.$options.createPlanRouteName);
    },
    /**
     * @description Получить локацию списка планов.
     * @param {number|string} patientId Идентификатор пациента.
     * @returns {any}
     */
    getListLocation(patientId) {
      return { name: 'ClinicPanelPatientPlanList', params: { id: patientId } };
    },
  },
};
